import { render } from "./customizeViewGoods.vue?vue&type=template&id=357b8d4c&ts=true"
import script from "./customizeViewGoods.vue?vue&type=script&lang=ts"
export * from "./customizeViewGoods.vue?vue&type=script&lang=ts"

import "./customizeViewGoods.vue?vue&type=style&index=0&id=357b8d4c&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__